import * as Sentry from "@sentry/react";
import {isSentryEnabled} from "../../instrument";

interface SentryUser {
  sub?: string;
  email?: string;
  preferred_username?: string;
}

export const setSentryUser = (user?: SentryUser): void => {
  if (!isSentryEnabled || !user?.sub) return;

  Sentry.setUser({
    id: user.sub,
    email: user.email,
    username: user.preferred_username ?? user.email,
  });
};

export const clearSentryUser = (): void => {
  if (!isSentryEnabled) return;
  Sentry.setUser(null);
};

export const captureSentryException = (error: unknown): void => {
  if (!isSentryEnabled) return;
  Sentry.captureException(error);
};
